import * as config from '../services/configParameters';

export const getUserCompleteName = (account = {}) => {
  if (config.USE_LEGACY_AUTH) {
    return account && account.name ? account.name.trim() : '';
  }
  return `${account.firstName || ''} ${account.lastName || ''}`.trim();
};